export default {
    baseStyle: {
        container: {
            display: 'flex',
            alignItems: 'flex-start'
        },
        label: {
            width: 'full',
            fontSize: '12px',
            lineHeight: '16.8px',
            letterSpacing: '0.01em'
        },
        control: {
            borderWidth: '1px',
            borderRadius: '0',
            borderColor: 'darkGray',
            backgroundColor: 'white',
            width: '12px',
            height: '12px',
            marginTop: '2px',
            _checked: {
                backgroundColor: 'fullBlack',
                borderColor: 'fullBlack',
                _disabled: {
                    backgroundColor: 'gray',
                    borderColor: 'gray'
                }
            },
            _disabled: {
                borderColor: 'gray'
            }
        }
    }
}
